/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadOnlyMonitoredObjectType
 */
export interface ReadOnlyMonitoredObjectType {
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectType
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectType
     */
    label?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectType
     */
    name?: string | null;
}

export function ReadOnlyMonitoredObjectTypeFromJSON(json: any): ReadOnlyMonitoredObjectType {
    return ReadOnlyMonitoredObjectTypeFromJSONTyped(json, false);
}

export function ReadOnlyMonitoredObjectTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyMonitoredObjectType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function ReadOnlyMonitoredObjectTypeToJSON(value?: ReadOnlyMonitoredObjectType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': value.label,
        'name': value.name,
    };
}


